// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"YoutubeGuide_wrapper__13g0I","title":"YoutubeGuide_title__3qZNr","frame":"YoutubeGuide_frame__1fhCk"};